import React from 'react';
import './sidePanel.css';

interface SidePanelProps {
    data: string | Record<string, any>; // Can accept either JSON string or object
    onClose: () => void;
}

const SidePanel: React.FC<SidePanelProps> = ({ data, onClose }) => {
    // Parse the data if it's a string
    const parsedData = React.useMemo(() => {
        if (typeof data === 'string') {
            try {
                return JSON.parse(data);
            } catch (e) {
                return { error: 'Invalid JSON data', raw: data };
            }
        }
        return data;
    }, [data]);

    // Helper function to format values
    const formatValue = (value: any): string => {
        if (value === null) return 'null';
        if (value === undefined) return 'undefined';
        if (typeof value === 'object') return JSON.stringify(value, null, 2);
        return String(value);
    };

    return (
        <div className="sidePanel-mainContainer">
            <div className="sidePanel-header">
                <h3>Data Details</h3>
                <button onClick={onClose} className="sidePanel-close-button">
                    &times;
                </button>
            </div>
            <div className="sidePanel-content">
                {Object.entries(parsedData).map(([key, value]) => (
                    <div key={key} className="sidePanel-data-row">
                        <div className="sidePanel-col-name">
                            <strong>{key}</strong>
                        </div>
                        <div className="sidePanel-col-value pre-wrap">
                            {formatValue(value)}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SidePanel